import { ComboboxPopoverProps, ComboboxProviderProps } from "@ariakit/react";
import { PlateEditor, Value } from "@udecode/plate-common";
import React, { useContext } from "react";

import { RichTextMentionData } from "./RichTextMentionPlugin";
import { MentionSuggestionSection } from "./mentionSearchSectionUtils";

export type DetailContainerPosition = "left" | "right";

export interface MentionComboboxProps {
  comboboxProviderProps?: Partial<ComboboxProviderProps>;
  comboboxContentProps?: Partial<ComboboxPopoverProps>;
  detailContainerPosition?: DetailContainerPosition;
}

export interface RichTextMentionContext {
  onMentionSearch: ((searchString: string) => Promise<RichTextMentionData[]>)[];
  showInDataBrowser?: (mention: RichTextMentionData.Table) => void;
  onSelectSideEffect?: (
    editor: PlateEditor<Value>,
    item: RichTextMentionData,
  ) => void;
  shouldGroupSuggestions?: boolean;
  groupSuggestionSections?: (
    suggestions: readonly RichTextMentionData[],
  ) => MentionSuggestionSection[];
  // Props for customizing the popover menu that appears when creating a
  // mention.
  comboboxProps?: MentionComboboxProps;
  // Prop for condensed formatting of table mentions in the logic view prompt bar
  condensedTableMentions?: boolean;
}

export const RichTextMentionContext =
  React.createContext<RichTextMentionContext>({
    onMentionSearch: [() => Promise.resolve([])],
  });

export function useRichTextMentionContext(): RichTextMentionContext {
  return useContext(RichTextMentionContext);
}
